import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { WebServicesService } from 'src/app/container/internal/internal-home/pages/webservices/webservices.service';
import { HomeExternalService } from 'src/app/container/external/shared/home/home-external.service';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import * as _ from 'lodash';
@Component({
  selector: 'app-donas2',
  templateUrl: './donas.component.html',
  styleUrls: ['./donas.component.scss']
})
export class Donas2Component implements OnInit {

  vistaRapidaActivo: VistaRapida = new VistaRapida();

  public doughnutChartType: ChartType = 'doughnut';

  public doughnutChartData = {
    labels: [
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.EXPEDIENTE.final'),
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.EXPEDIENTE.curso')
    ],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#28a745', '#007bff']
      }
    ]
  };

  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  }

  constructor(private translateService: TranslateService,
              private webServicesService : WebServicesService,
              private homeExternalService: HomeExternalService) { }

  ngOnInit(): void {
    if (this.webServicesService.vistaRapidaObj.active) {
      this.vistaRapidaActivo = _.cloneDeep(this.webServicesService.vistaRapidaObj);

      this.doughnutChartData.datasets[0].data = [
        this.vistaRapidaActivo.expedFinal,
        this.vistaRapidaActivo.expedCurso
      ];
    }

  if (this.homeExternalService.vistaRapidaObj.active) {
      this.vistaRapidaActivo = _.cloneDeep(this.homeExternalService.vistaRapidaObj);

      this.doughnutChartData.datasets[0].data = [
        this.vistaRapidaActivo.expedFinal,
        this.vistaRapidaActivo.expedCurso
      ];
    }
  }

  //event
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

  //event
  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

}